import { NavLink } from "react-router-dom";
import { tabBtnStyle } from "../../../styles";

export interface AdminSubNavItem {
  to: string;
  label: string;
  /** Passed through to NavLink's `end` — true for an index/default route whose
   *  path is a prefix of its siblings (e.g. "/admin/competitions/:id/gameweeks"
   *  should not stay "active" while on ".../gameweeks/:gwId"). */
  end?: boolean;
}

interface Props {
  items: AdminSubNavItem[];
}

/**
 * Replaces the tabBtnStyle button bars in AdminPage.tsx/AdminCompetitionPage.tsx that
 * used onClick + local useState to switch tabs. Renders NavLinks instead, so the
 * active tab lives in the URL — deep-linkable, browser-back works, no more hidden
 * navigation state.
 */
export default function AdminSubNav({ items }: Props) {
  return (
    <div style={{ display: "flex", gap: "0.25rem", padding: "0.75rem 1rem", overflowX: "auto" }}>
      {items.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.end}
          style={({ isActive }) => ({
            ...tabBtnStyle(isActive),
            flexShrink: 0,
            whiteSpace: "nowrap",
            textDecoration: "none",
          })}
        >
          {item.label}
        </NavLink>
      ))}
    </div>
  );
}
